import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Columns from "./components/Columns";
import Featured from "./components/Featured";
import Story from "./components/Story";
import About from "./components/About";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function HomePage() {
  const [category, setCategory] = useState<string>("all");

  return (
    <div className="min-h-screen bg-background-950 text-foreground-100">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Columns onPick={setCategory} />
        <Featured selected={category} onSelect={setCategory} />
        <Story />
        <About />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default HomePage;